export default __webpack_public_path__ + "static/1149-7630ca01e0258eedae1e630a5f640330.gif";